
import { Component} from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { ListProveedorComponent } from './list-proveedor/list-proveedor.component';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  styleUrls: ['./proveedores.component.scss'],
  providers:[ListProveedorComponent,MessagesTitles, MessagesStatus]
})
export class ProveedoresComponent{
  desbloqueoMasivo : boolean=false;
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  user: any;
  isAudit: boolean = false;
  
  readonly ROLE_ADMIN: number = environment.ROLE_ADMIN_ID;
  readonly ROLE_RIESGO: number = environment.ROLE_RIESGO_ID; // Rol Riesgo desde bd SecurityDBDev
  readonly ROLE_AUDIT: number = environment.ROLE_AUDIT_ID; // Rol Riesgo desde bd SecurityDBDev

  constructor(
    private loginService: LoginService,
    private listado:ListProveedorComponent) {
      
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.isAudit = this.userHasValidRole([this.ROLE_AUDIT]);
    }

    userHasValidRole(id_roles: number[]) {
      return id_roles.includes(this.user.id_roles);
    }
  clickGuard(){
    this.loginService.clickGuard = true;
 }
 AbrirPopupDesbloqueo(){
  this.desbloqueoMasivo = true;
}
CerrarPopupDesbloqueo(){
  this.desbloqueoMasivo = false;
  this.listado.cargarListado();
}

}
